import { z } from "zod";

export const FilterSchema = z.object({
    filter: z.object({
        property_id: z.string().min(1, "Property is required"),
        start_date: z.string().min(1, "Start date is required"),
        end_date: z.string().min(1, "End date is required"),
        date_base: z.enum(["checkin_date", "extra_date"]).optional(),
        room_type_id: z.string().nullable().optional(),
    }),
});

export type FilterSchemaType = z.infer<typeof FilterSchema>;
